<template>
    <div class="icon-container">
        <svg v-if="icon === 'paragraph'" xmlns="http://www.w3.org/2000/svg" fill="#2E3A59" viewBox="0 0 24 24">
          <path d="M15 19H3v-2h12v2zm6-4H3v-2h18v2zm-6-4H3V9h12v2zm6-4H3V5h18v2z" />
        </svg>
        <svg v-else-if="icon === 'image'" xmlns="http://www.w3.org/2000/svg" fill="#2E3A59" viewBox="0 0 24 24">
          <path
            d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2zM5 5v14h14V5H5zm13 12H6l3-4 1 1 3-4 5 7zm-9.5-6a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
          />
        </svg>
        <svg v-else-if="icon === 'image'" class="new-loader" version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
            <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
              <animateTransform 
                attributeName="transform" 
                attributeType="XML" 
                type="rotate"
                dur="1s" 
                from="0 50 50"
                to="360 50 50" 
                repeatCount="indefinite" />
          </path>
        </svg>
        <svg
            v-else-if="icon === 'plus'"
              xmlns="http://www.w3.org/2000/svg"
              fill="#2E3A59"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M5 6.41L10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41 17.59 5 12 10.59 6.41 5 5 6.41z"
              />
        </svg>
        <svg v-else-if="icon === 'delete'" xmlns="http://www.w3.org/2000/svg" fill="#2E3A59" viewBox="0 0 24 24">
            <path
            d="M17 22H7a2 2 0 01-2-2V7H3V5h4V4a2 2 0 012-2h6a2 2 0 012 2v1h4v2h-2v13a2 2 0 01-2 2zM7 7v13h10V7H7zm2-3v1h6V4H9zm6 14h-2V9h2v9zm-4 0H9V9h2v9z"
            />
        </svg>
    </div>
</template>
<script>
export default {
    name: 'Icons',
    props: {
        icon: {
            type: String,
            default: ''
        }
    }
}
</script>
<style lang="stylus" scoped>
    .icon-container
        width 100%
        display flex
        align-items center
        justify-content center
</style>